"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useMoney = function (prices) {
    var priceDisplay = usePlatformConfig_1.default().platformConfig.priceDisplay;
    var isPrimaryPrice = react_1.useCallback(function (price) { var _a; return ((_a = price) === null || _a === void 0 ? void 0 : _a.currency) === priceDisplay.primary.currency; }, [priceDisplay]);
    var isSecondaryPrice = react_1.useCallback(function (price) { var _a, _b; return ((_a = price) === null || _a === void 0 ? void 0 : _a.currency) === ((_b = priceDisplay.secondary) === null || _b === void 0 ? void 0 : _b.currency); }, [priceDisplay]);
    var getPrimaryPrice = react_1.useCallback(function (prices) { var _a; return (_a = prices) === null || _a === void 0 ? void 0 : _a.find(isPrimaryPrice); }, [priceDisplay]);
    var getSecondaryPrice = react_1.useCallback(function (prices) { var _a; return (_a = prices) === null || _a === void 0 ? void 0 : _a.find(isSecondaryPrice); }, [priceDisplay]);
    var primaryPrice = getPrimaryPrice(prices);
    var secondaryPrice = getSecondaryPrice(prices);
    return { primaryPrice: primaryPrice, secondaryPrice: secondaryPrice };
};
exports.default = useMoney;
